module.exports = __webpack_public_path__ + "img/Sistema-Construcao-Orcamento.2a6a258a.jpg";